import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMacao = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1472)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.087 11.4996C13.7924 11.4996 13.5128 11.5583 13.2531 11.6518C13.3953 11.3348 13.4907 10.982 13.4907 10.6052C13.4907 9.11457 12.0001 7.99655 12.0001 7.99655C12.0001 7.99655 10.5094 9.11457 10.5094 10.6052C10.5094 10.9819 10.6048 11.3348 10.747 11.6518C10.4873 11.5584 10.2076 11.4996 9.91313 11.4996C8.42246 11.4996 7.30444 12.9903 7.30444 12.9903C7.30444 12.9903 8.42246 14.481 9.91313 14.481C10.7871 14.481 11.5325 13.9688 12.0001 13.5447C12.4677 13.9687 13.2131 14.481 14.0871 14.481C15.5777 14.481 16.6958 12.9903 16.6958 12.9903C16.6958 12.9903 15.5776 11.4996 14.087 11.4996Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 4.69565L12.3079 5.64327H13.3043L12.4983 6.22902L12.806 7.17665L12 6.5909L11.194 7.17665L11.5017 6.22902L10.6956 5.64327H11.6921L12 4.69565Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.21095 6.35309L8.80335 6.88643L9.49368 6.4879L9.1695 7.2161L9.76186 7.74954L8.96911 7.6662L8.64492 8.3944L8.47907 7.61473L7.68637 7.53138L8.37665 7.13276L8.21095 6.35309Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.43723 9.12689L6.21694 9.29259L6.61552 8.60226L6.69887 9.39497L7.47849 9.56081L6.75033 9.88505L6.83368 10.6777L6.30019 10.0854L5.57204 10.4096L5.97062 9.71925L5.43723 9.12689Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.7891 6.35309L15.1967 6.88643L14.5064 6.4879L14.8305 7.2161L14.2382 7.74954L15.0309 7.6662L15.3551 8.3944L15.521 7.61473L16.3137 7.53138L15.6234 7.13276L15.7891 6.35309Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.5628 9.12689L17.7831 9.29259L17.3846 8.60226L17.3012 9.39497L16.5216 9.56081L17.2497 9.88505L17.1664 10.6777L17.6999 10.0854L18.428 10.4096L18.0295 9.71925L18.5628 9.12689Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 18.6549C13.1841 18.6549 14.2755 18.2599 15.1511 17.5951H8.84897C9.7245 18.2598 10.8159 18.6549 12 18.6549Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.21719 15.5245C7.3828 15.9035 7.5928 16.2585 7.83946 16.5843H16.1606C16.4073 16.2585 16.6173 15.9035 16.7829 15.5245H7.21719Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1472",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMacao;
